// extracted by mini-css-extract-plugin
module.exports = {"touchable":"style_touchable__9cdaC","touching":"style_touching__sPn6I"};